import React,{useEffect,useRef} from 'react';
import { FaWindowClose } from 'react-icons/fa'
// Direct file import — going through the '.' barrel creates a module cycle
// (barrel → Navbar → UserProfile → barrel) that crashes init. See Notification.
import Button from './Button';
import { userProfileData } from '../data/dummy';
import { useStateContext } from '../contexts/ContextProvider';
import avatar from '../data/avatar.jpg';
import { useNavigate } from 'react-router-dom';
import { ImCross } from "react-icons/im";
import AuthService from '../services/authService';
import { resetFirebaseChatAuth } from '../services/firebaseChatAuth';

const UserProfile = ({user}) => {
  const { currentColor } = useStateContext();
    const { setIsClicked, initialState } = useStateContext();
   const profileRef = useRef(null);
  const navigate = useNavigate()

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (profileRef.current && !profileRef.current.contains(event.target)) {
        setIsClicked && setIsClicked(initialState);  // Call the provided onClose function
      }
    };
    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [setIsClicked]);

  return (
    <div ref={profileRef}
 className="nav-item absolute right-1 top-16 bg-white dark:bg-[#42464D] p-3 rounded-lg w-100 shadow-lg">
      <div className="flex justify-between items-center">
        <p className="font-semibold text-lg dark:text-gray-200">User Profile</p>
        <Button
  icon={<ImCross size={10} />}
  color="#fba86f"
  bgHoverColor="orange"
  size="md"
  styles={{
    width: '30px',       // Equal width and height
    height: '30px',
    borderRadius: '50%', // Fully circular
    padding: '0',        // Remove padding
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }}
/>

      </div>
      <div className="flex gap-5 items-center border-color border-b-1">
        <img
          className="rounded-full h-20 w-20"
          src={avatar}
          alt="user-profile"
        />
        <div>
          <p className="font-semibold text-md dark:text-gray-200"> {user?.user?.first_name + ' ' + user?.user?.last_name} </p>
          <p className="text-gray-500 text-sm dark:text-gray-400">  Administrator   </p>
          <p className="text-gray-500 text-sm font-semibold dark:text-gray-400"> {user?.user?.email} </p>
        </div>
      </div>
      {/* <div>
        {userProfileData.map((item, index) => (
          <div key={index} className="flex gap-5 border-b-1 border-color p-4 hover:bg-light-gray cursor-pointer  dark:hover:bg-[#42464D]">
            <button
              type="button"
              style={{ color: item.iconColor, backgroundColor: item.iconBg , border: '1px solid'}}
              className="m-auto h-12 text-xl rounded-lg p-3 hover:bg-light-gray"
            >
              {item.icon}
            </button>

            <div>
              <p className="font-semibold dark:text-gray-200 ">{item.title}</p>
              <p className="text-gray-500 text-sm dark:text-gray-400"> {item.desc} </p>
            </div>
          </div>
        ))}
      </div> */}
      <div className="mt-5">
        <Button
          color="white"
          bgColor={currentColor}
          text="Logout"
          customHandler= {async () => {
             // Revoke the Sanctum token server-side BEFORE clearing storage —
             // the logout request itself needs the stored token, and clearing
             // alone would leave the token valid on the backend.
             await AuthService.logout()
             // The Firebase chat session persists in IndexedDB and would
             // otherwise outlive the Sanctum one, leaving a signed-in chat
             // identity behind on a shared machine.
             await resetFirebaseChatAuth()
             localStorage.clear()
             navigate('/')
             window.location.reload()
          }}
          borderRadius="5px"
          width="full"
        />
      </div>
    </div>

  );
};

export default UserProfile;
